import { render, staticRenderFns } from "./ProductRelationship.vue?vue&type=template&id=79e80a14&scoped=true&"
import script from "./ProductRelationship.vue?vue&type=script&lang=js&"
export * from "./ProductRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e80a14",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ColorsProductV2: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ColorsProductV2.vue').default})
